import { createPopupStore } from './createPopupStore';

export type NoSubscriptionPopupPayload = {
  retry?: () => void;
};

export const useNoSubscriptionPopup = createPopupStore<NoSubscriptionPopupPayload>();
